import React from 'react';
import { Dashboard } from './view/Dashboard';
import './App.css';

function App() {
  return (
    <div className="app">
      <main className="app-main">
        <Dashboard />
      </main>
      <footer className="app-footer">
        <p>Powered by ziz digital &copy; {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

export default App;
